import { render, staticRenderFns } from "./EmployeeBranchInfo.vue?vue&type=template&id=32da33c8&"
import script from "./EmployeeBranchInfo.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports